import { z } from "zod";
export const organizationStyleSchema = z.string().max(500);
export const organizationStyleUpdateSchema = z.union([
    z.object({ draftId: z.string().min(1).max(200) }).strict(),
    z.object({ reset: z.literal(true) }).strict(),
]);
export const organizationStyleResponseSchema = z.object({
    style: organizationStyleSchema,
    canEdit: z.boolean(),
});
export const organizationStyleExampleSchema = z.object({
    id: z.string().min(1), source: z.enum(["history", "sample"]),
    text: z.string().max(3000), shortened: z.boolean(),
    preview: z.string().max(4000).optional(),
});
export const organizationStyleConditioningSchema = organizationStyleResponseSchema.extend({
    examples: z.array(organizationStyleExampleSchema).length(3),
    draftId: z.string().min(1).optional(),
});
export const organizationStylePreviewRequestSchema = z.object({
    feedback: z.string().trim().min(1).max(2000),
    draftId: z.string().min(1).max(200).optional(),
    exampleIds: z.array(z.string().min(1).max(200)).length(3),
    previousRewrites: z.array(z.string().max(4000)).length(3).optional(),
}).strict();
export const organizationStyleGenerationSchema = z.object({
    style: organizationStyleSchema,
    rewrites: z.array(z.string().trim().min(1).max(4000)).length(3),
}).strict();
